import { NavLink, useParams } from "react-router-dom";
import React, { useState, useEffect, Fragment } from "react";
import { AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxDelete } from "../Common/AsyncAjaxService";
import { utils, ResponseCode } from "../../utils/Utils";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import Loader from "../Common/Loader";
import NoRights from "../Common/NoRights";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from 'react-redux';
import $ from "jquery";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "../Controls/VGPopUp";
import useGenerateToken from "components/Hook/useGenerateToken";
import { useDispatch } from 'react-redux'
import useSession from "components/Hook/useSession";

const Searchdomain = (props) => {

     const { BusinessID, ReactBusinessId, ReactUserID, UserID, DomainSuggestTlds, WebsiteBuilderParentWebsite, IsViewAllowed, IsModifyAllowed } = useSelector((state) => state.Business);
     const dispatch = useDispatch();

     const params = useParams();

     const VagaroAPIEnum = {
          GetDomainSuggetion: "merchants/" + BusinessID + "/domains/suggest",
          GetDomainCart: "merchants/" + BusinessID + "/domains/carts",
          AddDomainInCart: "merchants/" + BusinessID + "/domains/carts",
          DeleteDomainCart: "merchants/" + BusinessID + "/domains/carts"
     };

     const [searchDomain, setsearchDomain] = useState(typeof params.domainname != 'undefined' && params.domainname != null && params.domainname != "" ? params.domainname : "");
     const [searchData, setsearchData] = useState(typeof params.domainname != 'undefined' && params.domainname != null && params.domainname != "" ? params.domainname : "");
     const [suggetionDomainList, setSuggetionDomainList] = useState([]);
     const [isLoading, setLoading] = useState(false);
     const [cartDomainList, setCartDomainList] = useState([]);
     const [cartDomainCount, setcartDomainCount] = useState(0);
     const [isRecordFound, setIsRecordFound] = useState("");

     const CheckSession = async () => {
          setLoading(true);
          return await useSession(dispatch, BusinessID, UserID, (data) => {
               setLoading(false);
               if (data == true) {
                    if (ReactBusinessId > 0 && (typeof params.domainname != 'undefined' && params.domainname != null && params.domainname != "")) {
                         GetDomainSuggetion(params.domainname);
                    }
                    CheckLogin();
               }
          });
     }

     useEffect(() => {
          CheckSession()
     }, []);

     const CheckLogin = () => {
          if (ReactBusinessId === -2) {
               window.location.replace(WebsiteBuilderParentWebsite + "login");
          }
     }
     const RemoveFilters = () => {
          setsearchData("");
          setSuggetionDomainList([]);
          setsearchDomain("");
          $("#forfocus").focus();
     }

     const OnKeyPressDomain = (val) => {
          if (val === "") {
               RemoveFilters();
          }
          else {
               setsearchData(val);
          }
     }

     const _handleKeyDown = (e) => {
          if (e.key === "Enter") {
               if (e.target.value === "") {
                    setsearchData("");
                    setSuggetionDomainList([]);
                    setsearchDomain("");
               }
               else {
                    let domainText = e.target.value.toLowerCase();
                    let suffixes = DomainSuggestTlds.split(',').map((extension) => '.' + extension);

                    for (const suffix of suffixes) {
                         if (domainText.endsWith(suffix)) {
                              domainText = domainText.slice(0, -suffix.length);
                         }
                    }
                    const parts = e.target.value.toLowerCase().split('.');
                    const lastPart = parts.pop();
                    const enteredValue = (parts.length >= 2 ? parts.join('.') : parts.join('')) + '.' + lastPart;
                    GetDomainSuggetion(domainText.replace(/[^a-zA-Z0-9]/g, ''), enteredValue);
                    e.target.blur();
               }
          }
     };

     const domainSearchResultHeight = (e) => {

          var wHeight = $(window).height();
          var titleHeight
          if ($(".domain-section-title").length) {
               titleHeight = $(".domain-section-title").outerHeight(true);
          } else {
               titleHeight = 0;
          }

          var tabHeight
          if ($(".get-domain-search").length) {
               tabHeight = $(".get-domain-search").outerHeight(true);
          } else {
               tabHeight = 0;
          }
          var actionbtn
          if ($(".domain-actions").length) {
               actionbtn = $(".domain-actions").outerHeight(true);

          } else {
               actionbtn = 0;
          }


          var calCardWrapperHeight = wHeight - titleHeight - tabHeight - actionbtn - 118;
          $(".get-domain-search-lists").css("max-height", calCardWrapperHeight);

     }

     const GetDomainSuggetion = async (domain, enteredValue) => {
          let searchkey;
          if (domain === "") {
               searchkey = ".";
          }
          else {
               searchkey = domain.replaceAll(/\s/g, '');
          }

          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               $("#forfocus").blur();
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetDomainSuggetion + "?Query=" + searchkey + "&Value=" + enteredValue,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {

                                        var domainList = data.data.data;
                                        domainList.map((d, i) => {
                                             d.isExactMatchDomain = false;
                                        })
                                        const suggetiondomain = domainList.filter(
                                             (col) => col.domain === enteredValue.toLowerCase()
                                        );
                                        if (suggetiondomain.length > 0) {
                                             const suggetionotherdomain = domainList.filter(
                                                  (col) => col.domain != enteredValue.toLowerCase()
                                             );
                                             suggetionotherdomain.map((d, i) => {
                                                  d.rank = i;
                                             })

                                             let suggetionList = [];
                                             suggetiondomain[0].isExactMatchDomain = true;
                                             suggetiondomain[0].rank = -1;
                                             Array.prototype.push.apply(suggetionList, suggetiondomain);
                                             Array.prototype.push.apply(suggetionList, suggetionotherdomain);
                                             setSuggetionDomainList(suggetionList);
                                        }
                                        else {
                                             data.data.data.map((d, i) => {
                                                  d.rank = -2;
                                             });
                                             setSuggetionDomainList(data.data.data);
                                        }
                                        setLoading(false);
                                        $("#forfocus").focus();
                                        if (data.data.data.length > 0) {
                                             setIsRecordFound(true);
                                        }
                                        else {
                                             setIsRecordFound(false);
                                        }
                                   } else {
                                        setLoading(false);
                                        setSuggetionDomainList([]);
                                        $("#forfocus").focus();
                                        setIsRecordFound(false);
                                        utils.ShowAlert("Alert!", "Sorry, " + searchkey + " domain is not available.", "OpenDialog", true);
                                   }
                              }
                              else {
                                   setLoading(false);
                                   setSuggetionDomainList([]);
                                   $("#forfocus").focus();
                                   setIsRecordFound(false);
                                   utils.ShowAlert("Alert!", "Sorry, " + searchkey + " domain is not available.", "OpenDialog", true);
                              }
                              setsearchDomain(searchkey);
                              domainSearchResultHeight();
                         }
                         catch (error) {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Suggetion Domain List",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Suggetion Domain List",
                              searchkey,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const CheckSessionDomain = async () => {
          setLoading(true);
          return await useSession(dispatch, BusinessID, UserID, (data) => {
               setLoading(false);
               if (data == true) {
                    if (ReactBusinessId > 0) {
                         GetCartDomainList(true);
                    }
                    utils.SetPageTitle("Domain Suggetion");
                    domainSearchResultHeight();
                    window.addEventListener('resize', domainSearchResultHeight);
               }
          });
     }

     useEffect(() => {
          CheckSessionDomain();
     }, [BusinessID]);


     const GetCartDomainList = async (isloading) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetDomainCart,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        var domaindata = data.data.data;
                                        setCartDomainList(domaindata);
                                        var CartDomainCount = domaindata.filter(
                                             (col) => col.available === true
                                        );
                                        setcartDomainCount(CartDomainCount.length);
                                        if (isloading) {
                                             setLoading(false);
                                             $("#forfocus").focus();
                                        }
                                   }
                                   else {
                                        if (isloading) {
                                             setLoading(false);
                                             $("#forfocus").focus();
                                        }
                                   }
                              }
                              else {
                                   if (isloading) {
                                        setLoading(false);
                                        $("#forfocus").focus();
                                   }
                              }

                              domainSearchResultHeight();
                         }
                         catch (error) {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Cart Domain List",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Cart Domain List",
                              null,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const DeleteDomainCart = async (domain) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to delete domain in cart.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxDelete(
                         VagaroAPIEnum.DeleteDomainCart + "/" + domain + "/" + UserID,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             GetCartDomainList(true);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Delete Domain Cart",
                                        null,
                                        ""
                                   );
                                   utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Delete Domain Cart",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const AddDomainInCart = async (domain, redirectcheckout) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "You do not have permission to add domain in cart.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    if (redirectcheckout) {
                         setLoading(true);
                    }
                    const Requestdata = {};
                    Requestdata.DomainName = domain;
                    Requestdata.UserID = UserID;
                    setLoading(true);
                    await AsyncAjaxPost(
                         VagaroAPIEnum.AddDomainInCart,
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             if (redirectcheckout) {
                                                  setLoading(false);
                                                  let a = document.createElement('a');
                                                  a.target = '_self';
                                                  a.href = "/business/" + params.StyleId + "/" + params.LayoutId + "/checkout";
                                                  a.click();
                                             }
                                             var FilterSuggetionDomain = suggetionDomainList.filter(
                                                  (col) => col.domain === domain
                                             );
                                             if (FilterSuggetionDomain.length > 0) {
                                                  FilterSuggetionDomain[0].isCartItemExists = true;
                                                  suggetionDomainList.map((d, i) => {
                                                       if (d.domain === domain) {
                                                            suggetionDomainList[i] = FilterSuggetionDomain[0];
                                                       }
                                                  })
                                                  setSuggetionDomainList(suggetionDomainList);
                                             }
                                             GetCartDomainList(true);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.RecordExists && redirectcheckout == true
                                   ) {
                                        setLoading(false);
                                        let a = document.createElement('a');
                                        a.target = '_self';
                                        a.href = "/business/" + params.StyleId + "/" + params.LayoutId + "/checkout";
                                        a.click();
                                   }
                                   else {
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Add Domain In Cart",
                                        null,
                                        ""
                                   );
                                   utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Add Domain In Cart",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }
     const EmptycartClose = () => {
          unmountComponentAtNode(document.getElementById("OpenDialog"));
     };

     const Emptycart = () => {
          return ReactDom.render(
               <VGPopUp
                    show={true}
                    onHide={EmptycartClose}
                    title="Your Cart is Empty"
                    body={"You have not added any items to your cart. Please select a domain."}
                    footer={
                         <button
                              className="v-button primary invisible-button w-25"
                              type="button"
                              onClick={EmptycartClose}
                         >
                              OK
                         </button>
                    }
                    isShowFooter={true}
               />,
               document.getElementById("OpenDialog")
          );
     };

     return (
          <Fragment>
               {isLoading && <Loader />}
               <div className={ReactBusinessId <= 0 ? "all-content-container no-access-main-content-wrapper" : "all-content-container main-content-wrapper"}>
                    {/* import left panel */}
                    {!props.inEditor && <Leftpanel
                         activateTab={"GeneralSetting"}
                         activatePage={"Domain"}
                    />}
                    {/* left end  */}
                    {(() => {
                         if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                              return (
                                   <Fragment>
                                        <NoRights />
                                   </Fragment>
                              )
                         } else {
                              return (
                                   <Fragment>
                                        <div className="page-root">
                                             <div className="page-content container">
                                                  <div className="getadomain-wrapper">
                                                       <div className="domain-section-title py-t16 widthback" style={{ marginBottom: "10px" }}>
                                                            {!props.inEditor ?
                                                                 <NavLink
                                                                      className="back-arrow domain-back"
                                                                      to={{ pathname: `${'/business/' + params.StyleId + "/" + params.LayoutId + "/domain"}` }}
                                                                 >
                                                                      
                                                                 </NavLink>
                                                                 :
                                                                 <div
                                                                      style={{ cursor: "pointer" }}
                                                                      className="back-arrow domain-back"
                                                                      onClick={() => {
                                                                           props.setMenu && props.setMenu(1);
                                                                      }}
                                                                 >
                                                                      
                                                                 </div>

                                                            }
                                                            Get a Domain
                                                            {cartDomainCount > 0 &&
                                                                 <NavLink
                                                                      className="cart-right cartlist"
                                                                      to={{ pathname: `${'/business/' + params.StyleId + "/" + params.LayoutId + "/checkout"}` }}
                                                                 >
                                                                      <span className="cart-icon"></span>{" "}
                                                                      <span className="num">{cartDomainCount}</span>
                                                                 </NavLink>
                                                            }
                                                            {cartDomainCount === 0 &&
                                                                 <NavLink
                                                                      className="cart-right cartlist"
                                                                      onClick={Emptycart}
                                                                 >
                                                                      <span className="cart-icon"></span>{" "}
                                                                      <span className="num">{cartDomainCount}</span>
                                                                 </NavLink>
                                                            }
                                                       </div>
                                                       <div className="get-domain-search">
                                                            <span className="domain-search-icon"></span>
                                                            <input
                                                                 className="form-control domain-search-control"
                                                                 type="text"
                                                                 autoComplete="off"
                                                                 placeholder="Search for domain name i.e. salon77west.com"
                                                                 defaultValue={searchData}
                                                                 value={searchData}
                                                                 onChange={(e) => OnKeyPressDomain(e.target.value = e.target.value.replace(/[^a-zA-Z0-9\-\.]/g, ''))}
                                                                 maxLength={60}
                                                                 onKeyDown={_handleKeyDown}
                                                                 id={"forfocus"}
                                                            />{searchData.length > 0 && (
                                                                 <div className="clear-domain-search" onClick={RemoveFilters}></div>)}
                                                       </div>



                                                       {searchDomain.length > 0 &&
                                                            <div className={`get-domain-search-lists ${suggetionDomainList.length > 4 && "hasscroll"}`}>
                                                                 {suggetionDomainList.map((d) => {
                                                                      return (
                                                                           d.isAvailable === false && d.isExactMatchDomain ?
                                                                                <Fragment>
                                                                                     <div className="get-domain-match-box get-domain-taken">
                                                                                          <div className="match-left">
                                                                                               <div className="get-lable-match">DOMAIN TAKEN</div>
                                                                                               <div className="get-mail-match">
                                                                                                    <div className="get-mail-close"><i class="fa-regular fa-circle-xmark"></i></div>
                                                                                                    <div className="get-mail-txt">{d.domain}</div>
                                                                                               </div>
                                                                                          </div>
                                                                                     </div>
                                                                                </Fragment> :
                                                                                d.price > 0 &&
                                                                                <Fragment>
                                                                                     {d.isExactMatchDomain ? <Fragment>

                                                                                          <div className="get-domain-match-box">
                                                                                               <div className="match-left">
                                                                                                    <div className="get-lable-match">EXACT MATCH</div>
                                                                                                    <div className="get-mail-match">
                                                                                                         <div className="get-mail-close"><i class="fa-regular fa-circle-xmark"></i></div>
                                                                                                         <div className="get-mail-txt">{d.domain}</div>
                                                                                                    </div>
                                                                                               </div>
                                                                                               <div className="match-right">
                                                                                                    <div className="get-price"> {d.currencySymbol}{d.price}/yr{" "}</div>
                                                                                                    <div class="w-button w-button-neutral" onClick={() => AddDomainInCart(d.domain, true)}>Checkout</div>
                                                                                               </div>
                                                                                          </div>
                                                                                     </Fragment> : <Fragment>
                                                                                          {d.rank == 0 &&
                                                                                               <div className="get-alternative-tlt">Alternative Domains</div>
                                                                                          }
                                                                                          <div className={d.isCartItemExists === false ? "get-domain-search-item" : "get-domain-search-item selected-domain"} onClick={(e) => d.isCartItemExists === false ? AddDomainInCart(d.domain, false) : ""}>
                                                                                               <div className="name">
                                                                                                    {d.domain}
                                                                                               </div>
                                                                                               <div className="cart-price">
                                                                                                    {d.currencySymbol}{d.price}/yr{" "}
                                                                                                    {d.isCartItemExists === false &&
                                                                                                         <span className="cart_icon" />
                                                                                                    }
                                                                                                    {d.isCartItemExists === true &&
                                                                                                         <span className="cart_icon" title="Domain already exists in your cart" />
                                                                                                    }
                                                                                               </div>
                                                                                          </div>
                                                                                     </Fragment>
                                                                                     }
                                                                                </Fragment>
                                                                      )
                                                                 })}
                                                                 {isRecordFound === false && suggetionDomainList.length === 0 && (typeof params.domainname == 'undefined' || params.domainname == null && params.domainname == "") &&
                                                                      <div>
                                                                           No result found.
                                                                      </div>
                                                                 }
                                                            </div>
                                                       }
                                                       {searchDomain.length === 0 &&
                                                            <div className={`get-domain-search-lists ${cartDomainList.length > 4 && "hasscroll"}`}>
                                                                 {cartDomainList.length > 0 && cartDomainList.map((d) => {
                                                                      return (
                                                                           <Fragment>
                                                                                <div className="get-domain-search-item selected-domain">
                                                                                     <div className="name">
                                                                                          {d.domain}
                                                                                     </div>
                                                                                     <div className="cart-price">
                                                                                          {d.available === false ?
                                                                                               <span>Taken</span> :
                                                                                               <Fragment><span className="three-dots-domain" >{d.currencySymbol + d.vagaroDomainCharge}/yr <span className='add-cart_icon' title='Domain already exists in your cart' /></span></Fragment>
                                                                                          }
                                                                                          <span className="three-dots">
                                                                                               <Dropdown className="moremenu dropdown">
                                                                                                    <Dropdown.Toggle className="more-3dot">
                                                                                                         <i
                                                                                                              className="far fa-ellipsis-v"
                                                                                                              aria-hidden="true"
                                                                                                         />
                                                                                                    </Dropdown.Toggle>
                                                                                                    <Dropdown.Menu align="end">
                                                                                                         <Dropdown.Item onClick={(e) => { DeleteDomainCart(d.domain) }}>
                                                                                                              Remove from cart
                                                                                                         </Dropdown.Item>
                                                                                                    </Dropdown.Menu>
                                                                                               </Dropdown>
                                                                                          </span>
                                                                                     </div>

                                                                                </div>
                                                                           </Fragment>
                                                                      )
                                                                 })}
                                                            </div>
                                                       }
                                                       {cartDomainList.length > 0 && cartDomainList.filter(x => x.available === true).length > 0 &&
                                                            <div className="checkout-actions domain-actions">
                                                                 <NavLink
                                                                      className="w-button w-button-primary"
                                                                      to={{ pathname: `${'/business/' + params.StyleId + "/" + params.LayoutId + "/checkout"}` }}
                                                                 >
                                                                      Checkout
                                                                 </NavLink>
                                                            </div>
                                                       }
                                                  </div>
                                             </div>
                                        </div>
                                   </Fragment>
                              )
                         }
                    })()}
               </div>
          </Fragment>
     );
};

export default Searchdomain;
